module.exports = __webpack_public_path__ + "static/kobold-and-orc-21d978594b4a882ef69eba4ed5e4a698.jpg";